import { render, staticRenderFns } from "./PerksLandingPage.vue?vue&type=template&id=3ef19051"
import script from "./PerksLandingPage.vue?vue&type=script&lang=js"
export * from "./PerksLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports